import {clickEvent} from "../../webpack/modules/events";
import {closeLoadingModal, openLoadingModal, openModalFromHtml} from "../../webpack/modules-optimized/modal";
import {
    removeWishListItem,
    saveWishListItem,
    toggleWishlistItem,
    updateWishListButton
} from "../../webpack/modules-optimized/wishlist";
import {ga4TrackSimpleEvent} from "../../webpack/modules/analytics";

clickEvent('.add-item-wish-list', true, async function(element, event) {
    event.preventDefault();

    if (!element.classList.contains('from-product')) openLoadingModal();
    else element.classList.add('blinker-fast');

    let productId = element.dataset.productId;
    let response = await toggleWishlistItem(productId);

    element.classList.remove('blinker-fast');

    let error = !response.done;
    let popup = response.popup;
    let added = response.action === 'added';
    setTimeout( function (){
        if (document.querySelector('.modal-loader')) closeLoadingModal();
        if (document.querySelector('#loadingModal')) closeLoadingModal();
    }, 400);

    if (error) {
        if (popup) openModalFromHtml(popup);
        window.facebookSignWithInit();
        google.accounts.id.renderButton(
            document.querySelector('#login-dialog').querySelector('.g_id_signin'),
            { type: "icon", size: "large", theme: "outline" }
        );
        return;
    }

    if (added) saveWishListItem(productId);
    else removeWishListItem(productId);
    updateWishListButton(element, added);

    ga4TrackSimpleEvent({
        event: element.dataset.analyticsEvent,
        method: added ? 'add_to_wishlist' : 'remove_from_wishlist'
    });
});
